import { Component, inject, signal } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { Scrap } from '@services/scrap.service';
import { Proxy } from '@models/scrap.model';
import { RouterModule } from '@angular/router';
import { Router } from '@services/route.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lgb-proxies-list',
  imports: [
    CommonModule,
    RouterModule,
    UiModule
  ],
  templateUrl: './proxies-list.html',
  styleUrl: './proxies-list.css',
})
export class ProxiesList {
  //services
  readonly scrapS=inject(Scrap);
  readonly router=inject(Router);

  //data
  readonly proxies=signal<Proxy[]>([]);

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    this.scrapS.getProxies()
      .subscribe(proxies => {
        this.proxies.set(proxies);
        this.loading.set(false);
      });
  }

  statutClass(proxy: Proxy){
    return {
      'status-error': proxy.state=='error',
      'status-success': proxy.state=='actif'
    }
  }

  removeProxy(proxy: Proxy){
    this.loading.set(true);
    this.scrapS.removeProxy(proxy.ref)
      .subscribe(() => {
        this.proxies().splice(this.proxies().findIndex(p => p.ref==proxy.ref), 1);
        this.proxies.set([...this.proxies()]);
        this.loading.set(false);
      });
  }
}
